import { PAGINGATION_DEFAULT } from '@const/pagination'

const initUserStoreList: TUserStoreManagementDetail.TState['userStoreList'] = {
  data: [],
  ...PAGINGATION_DEFAULT
}

const initSearchStoreList: TUserStoreManagementDetail.TState['searchUserStoreList'] = {
  data: [],
  ...PAGINGATION_DEFAULT
}

export const initialState: TUserStoreManagementDetail.TState = {
  userStoreList: initUserStoreList,
  originalUserStoreList: initUserStoreList,
  searchUserStoreList: initSearchStoreList,
  storesAdded: [],
  searchOriginalUserStoreList: initSearchStoreList,
  isFetchingUserStoreList: true,
  isSearchingUserStoreList: false,
  showCredentialGeneratorModel: false,
  isLoading: false,
  userStoreManagementDetail: {
    data: {
      userId: '',
      stores: [] as TUserStoreManagementDetail.StoreItem[],
      userName: '',
      emailAddress: '',
      phonenumber: '',
      dataUsage: '',
      registerDate: '',
      internalReview: '',
      videoCount: 0,
      status: 1,
      storeManagerName: '',
      isMasterManager: false
    }
  },
  isFetchingUserStoreDetail: true
}
